module.exports = __webpack_public_path__ + "static/media/arrow-up.4130f000.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/arrow-up.svg
// module id = 750
// module chunks = 0